import classNames from 'classnames';

import styles from './DropdownMenu.module.css';

export interface MenuSeparatorProps {
  className?: string;
}

/**
 * Horizontal divider between item groups inside a `DropdownMenu` (works in both the anchored
 * dropdown and the mobile sheet). Exposed as `role="separator"`, valid in `menu` and `listbox`.
 */
export function MenuSeparator({ className }: MenuSeparatorProps) {
  return <div role="separator" className={classNames(styles.separator, className)} />;
}
